import React, { useEffect, useState } from 'react';
import useSWR from 'swr';

import AssayCreationButton from '../../../assays/AssayCreationButton';
import CardHeader from '../../../common/Labels/CardHeader';
import CardView from '../../../common/CardView/CardView';
import PipelineAssayChartList from '../../../assays/PipelineAssayChartList/PipelineAssayChartList';

import { swrAssayBaselineFetcher } from '../../../../utils/api_functions/assayBaselineFetch';
import usePipelineData from '../../PipelineDataContext';
import useWorkspaceContext from '../../../workspaces/WorkspaceContext/WorkspaceContext';

export const PipelineInsightsTab = () => {
  const { pipeline } = usePipelineData();
  const { currentWorkspaceId } = useWorkspaceContext();
  const [singleInference, setSingleInference] = useState(null);

  // There's no need to keep checking if we already have the single inference.
  const shouldFetchSingleInference = () => {
    if (singleInference) return false;
    return [pipeline?.pipelineID, currentWorkspaceId, 1];
  }

  const {
    data,
  } = useSWR(shouldFetchSingleInference, swrAssayBaselineFetcher, { refreshInterval: 1000 })

  useEffect(() => {
    if (!data) return 

    data.json().then((data_json) => {
      if (data_json.length !== 0) {
        setSingleInference(data_json[0]);
      }
    });
  }, [data])

  return (
    <CardView>
      <div className="flex justify-between items-center text-center mb-2">
        <CardHeader className="mb-2">Assays</CardHeader>
        <AssayCreationButton disable={singleInference===null} inferenceData={singleInference}/>
      </div>
      <PipelineAssayChartList />
    </CardView>
  )
}

export default PipelineInsightsTab;
